var version = {
    "name":      "dativery",
    "buildDateCode": "20261104-161745",
    "buildDate": "Wed Nov 04 2026 16:17:45 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20261104-161745",
    "backupUIVersion": "2.2.0-20250522-134816"
}
;
 export default version;